<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-12 pt-3 pb-3 pl-4">
        <h3><i class="fas fa-user-clock"></i> Eventos - Followup</h3>
      </div>
    </div>
    <EventAdd v-if="showAdd" ref="EventAdd" v-on:Back="onBack" />
    <EventList v-else ref="EventList" v-on:New="onNew" v-on:Edit="onEdit"/>
  </div>
</template>
<script>
import Tools from '@/components/tools/Tools.js'
import EventAdd from './components/add/eventadd.vue'
import EventList from './components/list/eventlist.vue'

export default {
  name: 'Event',
  data () {
    return {
      showAdd: false
    }
  },
  components: {
    EventAdd,
    EventList
  },
  mounted () {
    // Tools.MinimizedSidebar()
  },
  methods: {
    onNew () {
      this.showAdd = true
    },
    onEdit (obj) {
      this.showAdd = true
      this.$nextTick(() => {
        this.$refs.EventAdd.onEdit(obj)
      })
    },
    onBack () {
      this.showAdd = false
      // this.$refs.EventList.onLoad()
    },
    onLoad () {
    }
  },
  beforeDestroy () {
    this.$eventHub.off('Filter')
    Tools.MinimizedASidebar()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/events/event.vue